/*
 * Copyright (c) 2021. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Chiranthana Thennakoon on 5/07/2021.
 */
import dpAddBarOperations from './dp-add-bar-operations.json';

const PermissionKeys = {
  SURF_DP_ADD_BAR_TOUR_ICON_ENABLE: 'SURF_DP_ADD_BAR_TOUR_ICON_ENABLE'
};

const exportDpAddBarOperations = () => {
  return dpAddBarOperations;
};

export { PermissionKeys, exportDpAddBarOperations };
